var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 19.0952L14.275 21L19 16.5556M1 21C1 16.7044 4.52576 13.2222 8.875 13.2222C10.5481 13.2222 12.0995 13.7376 13.375 14.6163M13.375 5.44444C13.375 7.89904 11.3602 9.88889 8.875 9.88889C6.38972 9.88889 4.375 7.89904 4.375 5.44444C4.375 2.98984 6.38972 1 8.875 1C11.3602 1 13.375 2.98984 13.375 5.44444Z",
    stroke: "#171719",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser1);
export default __webpack_public_path__ + "static/media/User1.172d945354ea1abcfcc0435810d49b16.svg";
export { ForwardRef as ReactComponent };